import { authFetch } from 'src/auth/utils';
import { envVariables } from 'src/common/utils/envVariables';

import { isEmpty } from 'lodash';
import { NotFoundError } from 'src/rSimInventory/Inventory/Actions/api/rSimActionsApi';
import { ESim } from '../../Inventory/models/esim';
import { fetchESimProfiles } from '../../Inventory/Profiles/api/eSimProfilesApi';

type FetchESimArgs = {
  eid: string;
};

export const fetchESim = async ({ eid }: FetchESimArgs, signal?: AbortSignal) => {
  const urlQuery = new URLSearchParams();
  if (eid) {
    urlQuery.append('searchEid', eid);
  }

  const searchParamsQuery = urlQuery.toString();

  let ENDPOINT: string = `${envVariables.VITE_ESIMS_INGESTION_API}/e-sims`;
  if (searchParamsQuery) {
    ENDPOINT += `?${urlQuery.toString()}`;
  }

  const esimProfilesResponse = await authFetch(ENDPOINT, {
    signal,
  });

  const esims: ESim[] = await esimProfilesResponse.json();

  if (isEmpty(esims)) {
    throw new NotFoundError();
  }

  const esim = esims[0];

  const esimProfiles = await fetchESimProfiles({ eid: esim.eid });

  return {
    ...esim,
    esimProfiles,
  };
};
